import React from 'react';

import { cn } from '@wwe-portal/ui/lib/lib';

export default function WarningIcon({
  className,
  ...props
}: Readonly<React.ComponentProps<'svg'>>) {
  return (
    <svg
      className={cn('fill-toolTipBgColor text-toolTipTextColor', className)}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect fill="current" height="20" rx="10" width="20" x="0" y="0" />
      <path
        d="M9.16141 5.90414C9.16141 5.61614 9.26141 5.37214 9.46141 5.17214C9.66141 4.97214 9.90141 4.87214 10.1814 4.87214C10.4694 4.87214 10.7134 4.97214 10.9134 5.17214C11.1134 5.37214 11.2134 5.61614 11.2134 5.90414C11.2134 6.19214 11.1134 6.43614 10.9134 6.63614C10.7134 6.83614 10.4694 6.93614 10.1814 6.93614C9.90141 6.93614 9.66141 6.83614 9.46141 6.63614C9.26141 6.43614 9.16141 6.19214 9.16141 5.90414ZM11.0334 7.59614V14.2441H9.34141V7.59614H11.0334Z"
        fill="currentColor"
      />
    </svg>
  );
}
